const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/finance/overview.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */

import { getFindFinanceProjectListQueryOptions } from '@api';
import { createTableQuerySchema } from '@common';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
const searchSchema = createTableQuerySchema({});
export const Route = createFileRoute('/_rootLayout/finance/overview')({
  validateSearch: search => searchSchema.parse(search),
  loader: async ({
    context: {
      queryClient
    },
    location
  }) => {
    queryClient.ensureQueryData(getFindFinanceProjectListQueryOptions(location.search));
    return {
      crumb: t('NAVIGATION.FINANCE'),
      to: '/finance/overview'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});